/**
 * Hook to get the currently active event
 * Components use this as the standard entry point for event-aware UI
 */

import { getCurrentEvent } from '../utils/events'
import { EventType } from '../utils/events/types'

export const useCurrentEvent = (): EventType | null => {
  return getCurrentEvent()
}

export { EventType }
